import { styled } from 'styled-components'

// Sticks to the bottom of the bag's scroll area, so the items scroll under it; the z-index clears the bag
// content's own layers (stacked tile thumbnails and the discount marker go up to 2). Its top padding only spaces
// it from the items, so taps there reach them.
export const Section = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 3;
  margin-top: auto;
  padding-top: 60px;
  pointer-events: none;
`

// Where the panel's gradient turns opaque; the blur fades in over the same stretch.
const PANEL_FADE_END = '46%'

export const Panel = styled.div`
  position: relative;
  background: linear-gradient(
    to bottom,
    transparent,
    ${({ theme }) => theme.colors.grayBackgroundWhite} ${PANEL_FADE_END}
  );
  pointer-events: auto;

  /* A blur on the panel itself starts at full strength on its top edge, cutting the items under it with a hard line. */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    backdrop-filter: blur(12px);
    mask-image: linear-gradient(
      to bottom,
      transparent,
      black ${PANEL_FADE_END}
    );
  }
`
